import React from "react";
import {
  DataFlowsDisclosuresPageConfig,
  DataFlowsDisclosuresPageContent,
} from "../../../data-map/data-flows/DataFlowsDisclosuresPage";
import { Routes } from "../../../../root/routes";
import { HRDataMapTabs } from "./HRDataMapTabs";

export function HRDataFlowsDisclosuresPage() {
  const HR_DATA_FLOWS_DISCLOSURES_CONFIG: DataFlowsDisclosuresPageConfig = {
    collectionContext: ["EMPLOYEE"],
    dashboardRoute: Routes.hrCenter.hrDataMap.dataFlows,
    breadcrumbSource: "Data Flows",
    breadcrumbSourceRoute: Routes.hrCenter.hrDataMap.dataFlows,
    headerElement: <HRDataMapTabs selectedTabKey="hr-data-flows" />,
  };

  return <DataFlowsDisclosuresPageContent config={HR_DATA_FLOWS_DISCLOSURES_CONFIG} />;
}
